import type { Grid } from '@syncfusion/ej2-grids';
import type { ResourcesModel } from '@syncfusion/ej2-schedule';
import { updateLinkedAutoCompleteFieldValue, getPrice } from './scheduleCommon';

export async function scheduleCreateDialog(peopleList: any[], packageList: any[], resources: ResourcesModel[], startDate: string, endDate: string, roomType: string, room: string) {

    await import('@syncfusion/ej2-base/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-buttons/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-calendars/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-dropdowns/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-inputs/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-navigations/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-popups/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-splitbuttons/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-notifications/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-grids/styles/bootstrap5.3.css');

    await import('../loadSyncfusion');

    const { Grid } = await import('@syncfusion/ej2-grids');

    const { format } = await import('date-fns');

    const { inputAutoComplete } = await import('./inputAutoComplete');
    const { dateSelection } = await import('./dateSelection');
    const { initialCreateInputs } = await import('./initialCreateInputs'); 
    const { scheduleSelectDropdown } = await import('./scheduleSelectDropdown');
    const { scheduleNumberInput } = await import('./scheduleNumberInput');

    const data = {
        personInfo: {
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            personId: ''
        },
        startDate: '',
        endDate: '',
        rooms: [
            { RoomType: '', Room: '', Rate: '', Adults: '1', Services: [undefined] as any[] }
        ],
        additionalServices: [] as any[],
        async init() {
            

            // const index = 0;
            // scheduleSelectDropdown("dropdown-roomtype-" + index, [], true, roomType);// args.data.RoomType);
            // scheduleSelectDropdown("dropdown-room-" + index, [], true, room);// args.data.Room);
            this.rooms[0].RoomType = roomType;
            this.rooms[0].Room = room;
            this.startDate = startDate;
            this.endDate = endDate;

                const self = this;
                const firstnameEle = await inputAutoComplete("input-firstname", self.personInfo.firstName, "First name", peopleList, "FirstName", function (e) {
                    self.personInfo.firstName = e.value;
                });
                const lastnameEle = await inputAutoComplete("input-lastname", self.personInfo.lastName, "Last name", peopleList, "LastName", function (e) {
                    self.personInfo.lastName = e.value;
                });
                const phoneEle = await inputAutoComplete("input-phone", self.personInfo.phone, "Phone no.", peopleList, "PhoneNumber", function (e) {
                    self.personInfo.phone = e.value;
                });
                const emailEle = await inputAutoComplete("input-email", self.personInfo.email, "Email", peopleList, "Email", function (e) {
                    self.personInfo.email = e.value;
                });
            
                const containerEle = document.getElementById('container_person-search-grid');
            
                const personSearchGrid = new Grid({
                    dataSource: [],
                    columns: [
                        { field: 'FirstName', headerText: 'First Name', width: 120 },
                        { field: 'LastName', headerText: 'Last Name', width: 120 },
                        { field: 'PhoneNumber', headerText: 'Phone', width: 120 },
                        { field: 'Email', headerText: 'Email', width: 120 }
                    ],
                    height: 'auto',
                    rowSelected: (args: any) => {
                        updateLinkedAutoCompleteFieldValue("input-firstname", args.data.FirstName);
                        updateLinkedAutoCompleteFieldValue("input-lastname", args.data.LastName);
                        updateLinkedAutoCompleteFieldValue("input-phone", args.data.PhoneNumber);
                        updateLinkedAutoCompleteFieldValue("input-email", args.data.Email);
                        self.personInfo.personId = args.data.PersonId
            
                        containerEle.style.display = "none"
                    },
                    dataBound: () => {
                        if (personSearchGrid.currentViewData.length === 0) {
                            // hide when no record found.
                            containerEle.style.display = "none"
                            self.personInfo.personId = ''
                        }
                    }
                });
            
                personSearchGrid.appendTo("#person-search-grid");
            
                containerEle.addEventListener('focusout', (event: FocusEvent) => {
                    if (!(personSearchGrid.element.contains(event.target as Node) ||
                        firstnameEle.element.contains(event.target as Node) ||
                        lastnameEle.element.contains(event.target as Node) ||
                        phoneEle.element.contains(event.target as Node) ||
                        emailEle.element.contains(event.target as Node)) && containerEle.style.display !== "none") {
                        containerEle.style.display = "none"
                    }
                });
                document.addEventListener('click', (event: MouseEvent) => {
                    if (!(personSearchGrid.element.contains(event.target as Node) ||
                        firstnameEle.element.contains(event.target as Node) ||
                        lastnameEle.element.contains(event.target as Node) ||
                        phoneEle.element.contains(event.target as Node) ||
                        emailEle.element.contains(event.target as Node)) && containerEle.style.display !== "none") {
                        containerEle.style.display = "none"
                    }
                });

                await dateSelection(`dropdown-start`, startDate, function (e) {
                    self.startDate = e.value.toISOString();
                });
                await dateSelection(`dropdown-end`, endDate, function (e) {
                    self.endDate = e.value.toISOString();
                });
            
        },
        addRoom() {
            this.rooms.push({ RoomType: '', Room: '', Rate: '', Adults: '1', Services: [undefined] });
        },
        removeRoom(index: any) {
            this.rooms.splice(index, 1);
        },
        updateServices(roomIndex: any) {
            const room = this.rooms[roomIndex];
            const numAdults = room.Adults;
            if (numAdults >
                room.Services.length) {
                // Add services if the number of adults increased
                for (let i = room.Services.length; i < numAdults; i++) {
                    room.Services.push(undefined);
                }
            } else if (numAdults < room.Services.length) {
                // Remove services if the number of adults decreased
                room.Services.splice(numAdults);
            }
        },
        addAdditionalService() {
            this.additionalServices.push({ name: undefined, amount: 0 });
            console.log(this.additionalServices.length)
        },
        removeAdditionalService(index: any) {
            this.additionalServices.splice(index, 1);
        },
        save() {
            // Handle saving the data here
            console.log('Saving booking data...', {
                personInfo: this.personInfo,
                startDate: this.startDate,
                endDate: this.endDate,
                rooms: this.rooms,
                additionalServices: this.additionalServices
            });
            this.closePopup();
        },
        async initRoom(index: any) {
            await initialCreateInputs(this, index,
                packageList,
                resources)
        },
        async initAdult(index: any, adultIndex: any) {
            console.log('init adult', index, adultIndex)
            var self = this;
            await scheduleSelectDropdown('dropdown-service-' + index + '-' + adultIndex, packageList, true, null, function (e) {
                const services = self.rooms[index].Services
                services[adultIndex] = e.itemData.Value;
                const rooms = self.rooms;
                rooms[index].Services = services

                self.rooms = rooms;

                // add on change program should trigger price query
                // const priceButton = document.getElementById("button_package-price-" + index + '-' + adultIndex) as HTMLButtonElement;
                // priceButton.click();
                getPrice('packages={\"'+e.itemData.Value+'\":1}', 'text_package-price-'+index+'-'+adultIndex);
            })

        },
        async initProgramOnly(programOnlyIndex: any) {
            var self = this;
            await scheduleSelectDropdown('dropdown-programonly-' + programOnlyIndex, packageList, true, self.additionalServices[programOnlyIndex].name, function (e) {
                self.additionalServices[programOnlyIndex].packageId = e.value;

                // getPrice('packages={\"'+e.Value+'\":1}', 'text_package-price-'+index+'-'+adultIndex);
            });

            await scheduleNumberInput('number-programonly-' + programOnlyIndex, self.additionalServices[programOnlyIndex].amount, function (e) {
                self.additionalServices[programOnlyIndex].amount = e.value;
            });
        },
        getVals(addProps: string) {
            const data = {
                personInfo: this.personInfo,
                rooms: this.rooms,
                startDate: this.startDate,
                endData: this.endDate,
                additionalServices: this.additionalServices
            };

            if (!addProps) {
                return JSON.stringify(data);
            }
            
            console.log(addProps)
            const jsonText = addProps.replace(/(\w+)\s*:\s*([\w]+)/g, '"$1": "$2"');
            const propObj = JSON.parse(jsonText);
            console.log(propObj)
            return JSON.stringify({
                ...data,
                ...propObj
            })

        },
        get postStart() {
            console.log(this.startDate)
            if (this.startDate === '') return ''
            return format(this.startDate, 'yyyy-MM-dd')
        },
        get postEnd() {
            console.log(this.endDate)
            if (this.endDate === '') return ''
            return format(this.endDate, 'yyyy-MM-dd')
        },
        get postPrograms() {
            return JSON.stringify(this.additionalServices)
        },
        get postRooms() {
            return JSON.stringify(this.rooms)
        },
        getPackagePrice(index: number, adultIndex: number) {
            return JSON.stringify({
                "ChangesModel.Posted": "true",
                "ChangesModel.Start": this.postStart,
                "ChangesModel.End": this.postEnd,
                "ChangesModel.Programs": "{ '" + this.rooms[index].Services[adultIndex] + "' : 1 }",
                "ChangesModel.Rooms": "{}"
            })
        }
    }

    return data;
}
